import React, { FC, useRef, useState } from "react";
import { Helmet } from "react-helmet-async";
import Input from "shared/Input/Input";
import { Link } from "react-router-dom";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import { useLoginMutation } from "store/api";
import { useAuth } from "contexts/AuthContext";

export interface PageLoginProps {
  className?: string;
}


const PageLogin: FC<PageLoginProps> = ({ className = "" }) => {
  const username = useRef<HTMLInputElement>(null);
  const password = useRef<HTMLInputElement>(null);
  const [alert, setAlert] = useState<string | null>(null);
  const [login] = useLoginMutation();
  const {login:loginAuth}= useAuth();

  const handleSubmit = async(event:React.FormEvent) => {
    event.preventDefault();
    if (username.current?.value==='' || password.current?.value==='' ) {
      setAlert('Por favor, rellena todos los campos');
      setTimeout(() => setAlert(null), 2000);
      return;
    }else{
      const {error, data} = await login({email:username.current?.value,password:password.current?.value});
      if (error) {
        if ('status' in error) {
          const fetchError = error as { status: number; data: { message: string; statusMessage: string } };
          switch (fetchError.status) {
            case 401:
              setAlert('Usuario o contraseña incorrectos');
              break;
            case 404:
              setAlert('Usuario no encontrado');
              break;
            case 500:
              setAlert('Error en el servidor. Intenta más tarde.');
              break;
            default:
              setAlert('Algo salió mal. Intenta nuevamente.');
          }
          setTimeout(() => setAlert(null), 2000);
        }
      } else{
        const { customer, token } = data;
        const { password, fcm, ...userWithoutSensitiveData } = customer;
        loginAuth({ ...userWithoutSensitiveData, token });      }
    }
  };
  return (
    <div className={`nc-PageLogin ${className}`} data-nc-id="PageLogin">
      <Helmet>
        <title>Bee || Login</title>
      </Helmet>
      <div className="container mb-24 lg:mb-32">
        <h2 className="my-20 flex items-center text-3xl leading-[115%] md:text-5xl md:leading-[115%] font-semibold text-neutral-900 dark:text-neutral-100 justify-center">
          Login
        </h2>
        <div className="max-w-md mx-auto space-y-6">
          {/* FORM */}
          <form className="grid grid-cols-1 gap-6" onSubmit={handleSubmit}>
            <label className="block">
              <span className="text-neutral-800 dark:text-neutral-200">
                Correo o usuario
              </span>
              <Input
                ref={username}
                className="mt-1"
              />
            </label>
            <label className="block">
              <span className="flex justify-between items-center text-neutral-800 dark:text-neutral-200">
                Contraseña
                <Link to="/forgot-pass" className="text-sm">
                  Olvidaste tu contraseña?
                </Link>
              </span>
              <Input type="password" className="mt-1" ref={password}/>
            </label>
            <ButtonPrimary type="submit">Continuar</ButtonPrimary>
          </form>

          {/* ==== */}
          <span className="block text-center text-neutral-700 dark:text-neutral-300">
            Usuario nuevo? {` `}
            <Link to="/signup">Crear una cuenta</Link>
          </span>
        </div>
      </div>
      {alert && (
          <div className="fixed bottom-8 left-1/2 transform -translate-x-1/2 bg-red-600 text-white px-6 py-3 rounded-2xl shadow-2xl transition-all duration-300 ease-in-out opacity-90 hover:opacity-100 hover:scale-105 flex items-center gap-4">
            {alert}
          </div>
        )}
        
    </div>
  );
};

export default PageLogin;
